import { render, staticRenderFns } from "./prescriptionResult.vue?vue&type=template&id=859ff11a&scoped=true"
import script from "./prescriptionResult.vue?vue&type=script&lang=js"
export * from "./prescriptionResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859ff11a",
  null
  
)

export default component.exports